import axiosInstance from '@/plugins/api/axiosInstance';
import FormData from 'form-data';
import generateQueryParams from '@/utils/generateQueryParams';

export default function agencies() {
    return {
        index,
        create,
        update,
        getAgencyDetail,
        deleteAgency
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`agency/search${params}`);
    }

    function create(payload) {
        let data = new FormData();
        for (let key in payload) {
            data.append(key, payload[key]);
        }

        const config = {
            method: 'post',
            url: 'agency/create',
            headers: {
                'Content-Type': `multipart/form-data`
            },
            data: data
        };

        return axiosInstance(config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.error(error);
                throw error.data;
            });
    }

    function update(payload) {
        let data = new FormData();
        for (let key in payload) {
            data.append(key, payload[key]);
        }

        const config = {
            method: 'post',
            url: 'agency/update',
            headers: {
                'Content-Type': `multipart/form-data`
            },
            data: data
        };

        return axiosInstance(config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.error(error);
                throw error.data;
            });
    }

    function getAgencyDetail(id) {
        return axiosInstance.get(`agency/get?id=${id}`);
    }

    function deleteAgency(payload) {
        return axiosInstance.delete(`agency/delete`, {
            data: JSON.stringify(payload)
        });
    }
}
